module.exports = __webpack_public_path__ + "assets/04505755e1ee3c7d2c04cda8da3b375c.png";